import api from "./api";
import { API_URL_VERSION } from "../constants/environment";
import { toSearchFilter } from "utils/utils";

export const ENDPOINT_AUDITORIAS = API_URL_VERSION + 'auditorias'
export const ENDPOINT_AUDITORIAS_FIND_BY_ID = API_URL_VERSION + 'auditorias/'
export const ENDPOINT_AUDITORIAS_LIST = ENDPOINT_AUDITORIAS + '/listar'

export const auditsService = {
    find: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_AUDITORIAS_FIND_BY_ID}${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.audit.messages.errors.find";
        }
    },

    list: async (params = {}) => {
        try {
            const response = await api.post(ENDPOINT_AUDITORIAS_LIST, toSearchFilter(params));
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.audit.messages.errors.list";
        }
    }

};